import { Routes, Route, useLocation } from 'react-router-dom';
import React, { useLayoutEffect, useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileBottomNav from './components/MobileBottomNav';
import ReviewModal from './components/ReviewModal';
import './styles/App.css';
import PaymentSuccess from './components/PaymentSuccess';
import CategoryPage from './components/CategoryPage';
import Technicianbyservices from "./components/ServiceTechnicianPage.jsx"
import PrivacyPolicy from './Extra/Privacy.jsx';
import InfoPages from './Pages/InfoPages';
import eventBus from './eventBus';

// Pages
import Home from './Pages/Home';
import Services from './Pages/Services';
import HowItWorks from './Pages/HowItWorks.js';
import BrowseTasks from './Pages/BrowseTasks.jsx';
import Login from './Pages/Login';
import TechSignup from './Pages/TechSignup';
import UserProfile from './Pages/UserProfile';
import TechDashboard from './Pages/TechDashboard';
import TechProfile from './Pages/TechProfile';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [notificationStep, setNotificationStep] = useState(1);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationData, setNotificationData] = useState(null); // Add this state

  // Updated openReviewModal to accept data
  const openReviewModal = (data) => {
    console.log('Opening review modal with data:', data);
    setNotificationData(data); // Store the notification data
    setShowReviewModal(true);
    setShowNotification(false);
  };

  const closeReviewModal = () => {
    setShowReviewModal(false);
    setNotificationData(null); // Clear the data on close
    eventBus.emit('feedbackUpdated');
  };

  const nextNotificationStep = (step) => {
    setNotificationStep(step);
  };

  return (
    <main>
      <ScrollToTop />
      <Header 
        openReviewModal={openReviewModal}
        showNotification={showNotification}
        setShowNotification={setShowNotification}
        notificationStep={notificationStep}
        nextNotificationStep={nextNotificationStep}
      />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/browse-tasks" element={<BrowseTasks />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<TechSignup />} />
        <Route path="/profile" element={<UserProfile openReviewModal={openReviewModal} />} />
        <Route path="/tech-dashboard" element={<TechDashboard />} />
        <Route path="/tech-profile/:id" element={<TechProfile />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/category/:categoryId" element={<CategoryPage />} />
        <Route path="/services/:serviceId?" element={<Technicianbyservices />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<InfoPages />} />
        <Route path="/careers" element={<InfoPages />} />
        <Route path="/contact" element={<InfoPages />} />
        <Route path="/help-center" element={<InfoPages />} />
        <Route path="/terms-and-conditions" element={<InfoPages />} />
        <Route path="*" element={<Home />} />
      </Routes>
      
      <Footer />
      <MobileBottomNav />
      
      {/* Pass notificationData to ReviewModal */}
      <ReviewModal 
        show={showReviewModal} 
        onClose={closeReviewModal}
        notificationData={notificationData} // Add this prop
      />
    </main>
  );
}

export default App;